module.exports = __webpack_public_path__ + "static/img/digita_05.6c1da40b.jpg";